import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SchemaOrg from '../../components/feature/SchemaOrg';

export default function CaseDetail1Page() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const processSteps = [
    {
      title: '現場評估',
      time: '搬家前 3 天',
      description: '專業團隊到府評估，測量家具尺寸，規劃搬運路線',
      image: 'https://public.readdy.ai/ai/img_res/c5fe7571dde33a907252573ae9cdbf78.jpg'
    },
    {
      title: '專業打包',
      time: '搬家前 1 天',
      description: '使用專業包裝材料，為易碎品和貴重物品提供完善保護',
      image: 'https://readdy.ai/api/search-image?query=Professional%20movers%20carefully%20wrapping%20and%20packing%20household%20items%20with%20bubble%20wrap%20and%20protective%20materials%20in%20Taiwan%20home%2C%20organized%20labeled%20boxes%2C%20systematic%20packing%20process%2C%20quality%20packing%20supplies&width=800&height=600&seq=case-detail-1-step2&orientation=landscape'
    },
    {
      title: '家具拆裝',
      time: '搬家當天上午',
      description: '專業工具拆卸大型家具，標記零件，確保重組順利',
      image: 'https://readdy.ai/api/search-image?query=Skilled%20workers%20disassembling%20large%20furniture%20with%20professional%20tools%20in%20Taiwanese%20residence%2C%20organized%20parts%20and%20hardware%2C%20careful%20furniture%20dismantling%20process%2C%20systematic%20labeling%20system&width=800&height=600&seq=case-detail-1-step3&orientation=landscape'
    },
    {
      title: '安全搬運',
      time: '搬家當天',
      description: '使用專業搬運設備，團隊協作，確保物品安全運送',
      image: 'https://readdy.ai/api/search-image?query=Professional%20moving%20team%20carefully%20carrying%20furniture%20down%20stairs%20in%20Taiwan%20apartment%20building%2C%20safety%20equipment%20and%20protective%20gear%2C%20coordinated%20teamwork%2C%20secure%20item%20transport%20with%20straps%20and%20dollies&width=800&height=600&seq=case-detail-1-step4&orientation=landscape'
    },
    {
      title: '物品定位',
      time: '搬家當天下午',
      description: '按照客戶需求，將家具和物品擺放到指定位置',
      image: 'https://readdy.ai/api/search-image?query=Movers%20placing%20furniture%20in%20new%20Taiwan%20apartment%20according%20to%20floor%20plan%2C%20organized%20room%20setup%2C%20professional%20positioning%20service%2C%20clean%20modern%20interior%20space&width=800&height=600&seq=case-detail-1-step5&orientation=landscape'
    },
    {
      title: '完工驗收',
      time: '搬家當天傍晚',
      description: '清理現場，檢查物品完整性，確認客戶滿意後完成服務',
      image: 'https://readdy.ai/api/search-image?query=Happy%20customer%20inspecting%20completed%20moving%20service%20in%20new%20Taiwan%20home%2C%20clean%20organized%20space%2C%20satisfied%20homeowner%20with%20moving%20team%2C%20successful%20relocation%20completion&width=800&height=600&seq=case-detail-1-step6&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg 
        type="review" 
        data={{
          reviewRating: 5,
          reviewAuthor: '陳先生',
          reviewDate: '2024-01-15',
          reviewText: '建鈞搬家的服務真的很專業！從估價到搬家當天，每個環節都很細心。特別是鋼琴搬運，讓我非常放心。'
        }}
      />

      <Header />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-teal-600 to-emerald-600 overflow-hidden">
        <div className="absolute inset-0 bg-pattern opacity-10"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3 text-teal-100 mb-6">
            <Link to="/cases" className="hover:text-white transition-colors flex items-center gap-2">
              <i className="ri-arrow-left-line"></i>
              <span>返回案例列表</span>
            </Link>
            <span>/</span>
            <span className="text-white">案例詳情</span>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
                <i className="ri-home-4-line"></i>
                <span>家庭搬遷</span>
              </div>

              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                新北板橋 3 房家庭搬遷
              </h1>

              <p className="text-xl text-teal-100 mb-8 leading-relaxed">
                陳先生一家四口從板橋舊公寓搬到新大樓，包含大量書籍、家電和家具。我們提供完整的打包、搬運、定位服務，並特別注意鋼琴和古董家具的保護。
              </p>

              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4">
                  <div className="text-teal-100 text-sm mb-1">客戶姓名</div>
                  <div className="text-white text-lg font-semibold">陳先生</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4">
                  <div className="text-teal-100 text-sm mb-1">搬遷地點</div>
                  <div className="text-white text-lg font-semibold">新北市板橋區</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4">
                  <div className="text-teal-100 text-sm mb-1">房屋坪數</div>
                  <div className="text-white text-lg font-semibold">35 坪</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4">
                  <div className="text-teal-100 text-sm mb-1">搬遷費用</div>
                  <div className="text-white text-lg font-semibold">$12,000</div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-teal-400 to-emerald-400 rounded-3xl blur-2xl opacity-30"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20three%20bedroom%20apartment%20interior%20in%20Taiwan%20with%20organized%20furniture%20and%20moving%20boxes%2C%20professional%20moving%20service%20in%20progress%2C%20clean%20bright%20family%20living%20space%20with%20complete%20household%20belongings&width=800&height=600&seq=case-detail-1-hero&orientation=landscape"
                alt="新北板橋家庭搬遷"
                className="relative rounded-3xl shadow-2xl w-full h-96 object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 客戶評價 */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-3xl p-8 md:p-12 shadow-lg">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-full flex items-center justify-center text-white text-3xl font-bold shadow-lg">
                陳
              </div>
              <div>
                <div className="text-2xl font-bold text-gray-900">陳先生</div>
                <div className="flex items-center gap-2 mt-2">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-2xl"></i>
                  ))}
                  <span className="text-gray-600 font-semibold ml-2">5.0 分</span>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-md">
              <div className="flex items-start gap-3">
                <i className="ri-double-quotes-l text-teal-600 text-4xl flex-shrink-0"></i>
                <div className="flex-1">
                  <p className="text-gray-700 text-lg leading-relaxed mb-4">
                    建鈞搬家的服務真的很專業！從估價到搬家當天，每個環節都很細心。特別是鋼琴搬運，讓我非常放心。師傅們動作俐落又小心，強烈推薦！
                  </p>
                  <p className="text-gray-700 text-lg leading-relaxed">
                    搬家過程中，師傅們不僅專業，態度也非常好。遇到問題會主動溝通，讓我們全家都很安心。價格也很合理，物超所值！
                  </p>
                </div>
                <i className="ri-double-quotes-r text-teal-600 text-4xl flex-shrink-0"></i>
              </div>
            </div>

            <div className="mt-6 flex items-center justify-between text-sm text-gray-600">
              <div className="flex items-center gap-2">
                <i className="ri-calendar-line"></i>
                <span>2024年1月15日</span>
              </div>
              <div className="bg-teal-100 text-teal-800 px-4 py-2 rounded-full font-semibold">
                已驗證客戶
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 搬家過程 */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">完整搬家流程</h2>
            <p className="text-xl text-gray-600">專業團隊，每個步驟都精心規劃</p>
          </div>

          <div className="space-y-16">
            {processSteps.map((step, index) => (
              <div key={index} className={`grid lg:grid-cols-2 gap-8 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  <div className="relative">
                    <div className="absolute -top-6 -left-6 w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg z-10">
                      {index + 1}
                    </div>
                    <img
                      src={step.image}
                      alt={step.title}
                      className="rounded-3xl shadow-2xl w-full h-96 object-cover object-top"
                    />
                  </div>
                </div>

                <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                  <div className="inline-flex items-center gap-2 bg-teal-100 text-teal-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
                    <i className="ri-time-line"></i>
                    <span>{step.time}</span>
                  </div>

                  <h3 className="text-3xl font-bold text-gray-900 mb-4">{step.title}</h3>
                  <p className="text-lg text-gray-700 leading-relaxed">{step.description}</p>

                  <div className="mt-6 bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-6">
                    <div className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-2xl flex-shrink-0 mt-1"></i>
                      <div>
                        <div className="font-semibold text-gray-900 mb-2">專業服務重點</div>
                        <ul className="space-y-2 text-gray-700">
                          {index === 0 && (
                            <>
                              <li>• 詳細記錄家具尺寸和數量</li>
                              <li>• 評估搬運難度和所需人力</li>
                              <li>• 提供精準報價和時間規劃</li>
                            </>
                          )}
                          {index === 1 && (
                            <>
                              <li>• 使用氣泡紙、保護墊等專業材料</li>
                              <li>• 易碎品特殊包裝處理</li>
                              <li>• 清楚標記箱子內容物</li>
                            </>
                          )}
                          {index === 2 && (
                            <>
                              <li>• 專業工具快速拆卸</li>
                              <li>• 零件分類標記保存</li>
                              <li>• 拍照記錄組裝方式</li>
                            </>
                          )}
                          {index === 3 && (
                            <>
                              <li>• 使用搬運推車和保護設備</li>
                              <li>• 團隊協作確保安全</li>
                              <li>• 貴重物品專人負責</li>
                            </>
                          )}
                          {index === 4 && (
                            <>
                              <li>• 按照平面圖擺放家具</li>
                              <li>• 重組拆卸的家具</li>
                              <li>• 協助調整到最佳位置</li>
                            </>
                          )}
                          {index === 5 && (
                            <>
                              <li>• 清理包裝材料和垃圾</li>
                              <li>• 檢查物品完整性</li>
                              <li>• 確認客戶滿意度</li>
                            </>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 搬家過程實拍 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-teal-100 text-teal-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-camera-line"></i>
              <span>真實記錄</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">搬家過程實拍照片</h2>
            <p className="text-xl text-gray-600">每個細節都用心，每個步驟都專業</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20mover%20wrapping%20piano%20with%20thick%20protective%20blankets%20and%20padding%20in%20Taiwan%20apartment%2C%20careful%20piano%20protection%20process%2C%20specialized%20instrument%20moving%20equipment&width=400&height=400&seq=case1-real-1&orientation=squarish"
                alt="鋼琴專業包裝"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">鋼琴專業包裝</p>
                  <p className="text-white/80 text-sm">使用厚實保護墊全面包覆</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Moving%20team%20carefully%20carrying%20antique%20wooden%20furniture%20down%20narrow%20staircase%20in%20old%20Taiwan%20apartment%20building%2C%20coordinated%20teamwork%20with%20protective%20gloves&width=400&height=400&seq=case1-real-2&orientation=squarish"
                alt="古董家具搬運"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">古董家具搬運</p>
                  <p className="text-white/80 text-sm">小心翼翼搬運珍貴家具</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Organized%20moving%20boxes%20with%20clear%20labels%20stacked%20neatly%20in%20Taiwan%20home%2C%20systematic%20packing%20with%20room%20names%20and%20content%20descriptions%20written%20on%20boxes&width=400&height=400&seq=case1-real-3&orientation=squarish"
                alt="分類標記裝箱"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">分類標記裝箱</p>
                  <p className="text-white/80 text-sm">清楚標示方便整理</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20movers%20using%20furniture%20dolly%20to%20transport%20heavy%20wardrobe%20in%20Taiwan%20residential%20building%20hallway%2C%20safe%20equipment%20handling%20with%20straps&width=400&height=400&seq=case1-real-4&orientation=squarish"
                alt="專業推車搬運"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">專業推車搬運</p>
                  <p className="text-white/80 text-sm">使用專業設備省力安全</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Fragile%20items%20like%20glassware%20and%20ceramics%20being%20wrapped%20individually%20with%20bubble%20wrap%20and%20tissue%20paper%20in%20Taiwan%20home%2C%20careful%20packing%20of%20delicate%20items&width=400&height=400&seq=case1-real-5&orientation=squarish"
                alt="易碎品包裝"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">易碎品包裝</p>
                  <p className="text-white/80 text-sm">逐件包裝確保安全</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Moving%20truck%20cargo%20area%20with%20furniture%20and%20boxes%20secured%20with%20straps%20and%20padding%2C%20organized%20loading%20in%20Taiwan%20residential%20area%2C%20professional%20cargo%20arrangement&width=400&height=400&seq=case1-real-6&orientation=squarish"
                alt="貨車裝載固定"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">貨車裝載固定</p>
                  <p className="text-white/80 text-sm">綁帶固定防止移動</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Movers%20assembling%20bed%20frame%20with%20tools%20in%20new%20Taiwan%20apartment%20bedroom%2C%20furniture%20reassembly%20service%20after%20relocation%2C%20organized%20hardware%20and%20parts&width=400&height=400&seq=case1-real-7&orientation=squarish"
                alt="家具重新組裝"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">家具重新組裝</p>
                  <p className="text-white/80 text-sm">專業工具快速組裝</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Waterproof%20plastic%20covers%20protecting%20furniture%20and%20boxes%20during%20rainy%20day%20move%20in%20Taiwan%2C%20rain%20protection%20measures%20for%20moving%20service&width=400&height=400&seq=case1-real-8&orientation=squarish"
                alt="雨天防護措施"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">雨天防護措施</p>
                  <p className="text-white/80 text-sm">防水布全面保護</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 grid md:grid-cols-3 gap-6">
            <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">全程防護</h3>
              <p className="text-gray-600 text-sm">專業包裝材料，確保物品零損傷</p>
            </div>
            <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">專業團隊</h3>
              <p className="text-gray-600 text-sm">經驗豐富師傅，分工明確效率高</p>
            </div>
            <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">貼心服務</h3>
              <p className="text-gray-600 text-sm">細心處理每個環節，讓您安心</p>
            </div>
          </div>
        </div>
      </section>

      {/* Google 客戶評論照片 */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-google-fill"></i>
              <span>Google 評論</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">客戶分享的真實照片</h2>
            <p className="text-xl text-gray-600">來自 Google 地圖評論的真實搬家紀錄</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Customer%20photo%20of%20professional%20movers%20carefully%20wrapping%20large%20sofa%20with%20protective%20blankets%20in%20Taiwan%20living%20room%2C%20real%20moving%20service%20documentation%2C%20authentic%20customer%20review%20image&width=400&height=400&seq=google-review-1-1&orientation=squarish"
                alt="客戶分享 - 沙發包裝"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">陳先生分享</p>
                  <p className="text-white/80 text-xs">沙發包裝很仔細</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Real%20customer%20photo%20showing%20moving%20team%20loading%20furniture%20into%20truck%20in%20Taiwan%20residential%20area%2C%20authentic%20Google%20review%20image%20of%20professional%20moving%20service&width=400&height=400&seq=google-review-1-2&orientation=squarish"
                alt="客戶分享 - 裝車作業"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">王小姐分享</p>
                  <p className="text-white/80 text-xs">裝車很有效率</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Authentic%20customer%20review%20photo%20of%20neatly%20organized%20moving%20boxes%20with%20labels%20in%20new%20Taiwan%20apartment%2C%20real%20relocation%20documentation%20from%20satisfied%20customer&width=400&height=400&seq=google-review-1-3&orientation=squarish"
                alt="客戶分享 - 整齊裝箱"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">林太太分享</p>
                  <p className="text-white/80 text-xs">箱子標記清楚</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Customer%20shared%20photo%20of%20professional%20piano%20moving%20with%20specialized%20equipment%20in%20Taiwan%20home%2C%20real%20Google%20review%20image%20showing%20careful%20instrument%20handling&width=400&height=400&seq=google-review-1-4&orientation=squarish"
                alt="客戶分享 - 鋼琴搬運"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">張先生分享</p>
                  <p className="text-white/80 text-xs">鋼琴搬運超專業</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Real%20photo%20from%20customer%20showing%20movers%20carrying%20refrigerator%20with%20protective%20padding%20down%20stairs%20in%20Taiwan%20apartment%20building%2C%20authentic%20moving%20service%20review&width=400&height=400&seq=google-review-1-5&orientation=squarish"
                alt="客戶分享 - 家電搬運"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">黃小姐分享</p>
                  <p className="text-white/80 text-xs">冰箱搬運很小心</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Customer%20review%20photo%20showing%20completed%20living%20room%20setup%20after%20professional%20moving%20service%20in%20Taiwan%20new%20home%2C%20satisfied%20customer%20documentation&width=400&height=400&seq=google-review-1-6&orientation=squarish"
                alt="客戶分享 - 完成定位"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">吳先生分享</p>
                  <p className="text-white/80 text-xs">擺放位置剛剛好</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Authentic%20Google%20review%20photo%20of%20moving%20truck%20with%20company%20logo%20parked%20outside%20Taiwan%20apartment%20building%2C%20real%20customer%20documentation%20of%20professional%20service&width=400&height=400&seq=google-review-1-7&orientation=squarish"
                alt="客戶分享 - 搬運車輛"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">劉太太分享</p>
                  <p className="text-white/80 text-xs">車輛乾淨整潔</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Real%20customer%20photo%20of%20friendly%20moving%20team%20posing%20with%20thumbs%20up%20after%20successful%20relocation%20in%20Taiwan%2C%20authentic%20Google%20review%20showing%20happy%20service%20completion&width=400&height=400&seq=google-review-1-8&orientation=squarish"
                alt="客戶分享 - 服務完成"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">周先生分享</p>
                  <p className="text-white/80 text-xs">師傅態度超好</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-3xl shadow-xl p-8 mt-8">
            <div className="flex items-center justify-between flex-wrap gap-4">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-orange-400 rounded-full flex items-center justify-center shadow-lg">
                  <i className="ri-google-fill text-white text-3xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">Google 評論</div>
                  <div className="flex items-center gap-2 mt-1">
                    <div className="flex items-center gap-1">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                      ))}
                    </div>
                    <span className="text-gray-600 font-semibold">5.0 滿分好評</span>
                  </div>
                </div>
              </div>
              <a
                href="https://maps.google.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-teal-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-teal-700 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-external-link-line"></i>
                <span>查看更多評論</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 搬家挑戰與解決方案 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">搬家挑戰與解決方案</h2>
            <p className="text-xl text-gray-600">專業團隊，克服各種搬運難題</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-3xl p-8 shadow-lg">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center">
                  <i className="ri-alert-line text-white text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">搬家挑戰</h3>
              </div>

              <div className="space-y-4">
                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-close-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">舊家 5 樓無電梯</div>
                      <p className="text-gray-600 text-sm">需要人力搬運所有物品下樓，體力消耗大</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-close-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">鋼琴重達 250 公斤</div>
                      <p className="text-gray-600 text-sm">需要專業設備和技術才能安全搬運</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-close-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">古董家具需特殊保護</div>
                      <p className="text-gray-600 text-sm">價值高且易損，需要專業包裝</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-close-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">搬家當天下雨</div>
                      <p className="text-gray-600 text-sm">需要防潮措施保護物品</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-3xl p-8 shadow-lg">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center">
                  <i className="ri-lightbulb-line text-white text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">解決方案</h3>
              </div>

              <div className="space-y-4">
                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">安排 4 位專業搬運師傅</div>
                      <p className="text-gray-600 text-sm">充足人力確保搬運效率和安全</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">使用專業鋼琴搬運設備</div>
                      <p className="text-gray-600 text-sm">專用推車和保護墊確保安全</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">訂製木箱包裝古董家具</div>
                      <p className="text-gray-600 text-sm">量身打造保護方案</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">準備防水布和塑膠套</div>
                      <p className="text-gray-600 text-sm">全面防潮保護所有物品</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 bg-gradient-to-br from-teal-600 to-emerald-600 rounded-3xl p-8 text-center shadow-2xl">
            <div className="flex items-center justify-center gap-3 mb-4">
              <i className="ri-trophy-line text-yellow-300 text-4xl"></i>
              <h3 className="text-3xl font-bold text-white">搬家成果</h3>
            </div>
            <p className="text-xl text-teal-100 leading-relaxed max-w-3xl mx-auto">
              順利在 6 小時內完成搬遷，所有物品完好無損，客戶非常滿意我們的專業服務。鋼琴和古董家具都安全送達，沒有任何損傷。即使遇到下雨天氣，我們的防護措施也確保了所有物品保持乾燥。
            </p>
          </div>
        </div>
      </section>

      {/* 服務項目 */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">本次提供的服務</h2>
            <p className="text-xl text-gray-600">全方位搬家解決方案</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-box-3-line text-teal-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-3">專業打包</h3>
              <p className="text-gray-600 text-center text-sm">使用專業包裝材料，確保物品安全</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-music-line text-emerald-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-3">鋼琴搬運</h3>
              <p className="text-gray-600 text-center text-sm">專業設備和技術，安全搬運重型樂器</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-tools-line text-teal-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-3">家具拆裝</h3>
              <p className="text-gray-600 text-center text-sm">專業工具快速拆裝，不損傷家具</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-map-pin-line text-emerald-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-3">定位服務</h3>
              <p className="text-gray-600 text-center text-sm">按需求擺放家具，省時省力</p>
            </div>
          </div>
        </div>
      </section>

      {/* 更多案例 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">查看更多成功案例</h2>
            <p className="text-xl text-gray-600">每個案例都是我們的承諾</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <Link to="/case-detail-2" className="group">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20office%20space%20with%20computers%20and%20business%20equipment%20being%20professionally%20moved%20in%20Taipei%20Taiwan%2C%20organized%20commercial%20relocation%20service%2C%20IT%20equipment%20and%20office%20furniture%20transport&width=600&height=400&seq=more-case-1&orientation=landscape"
                    alt="辦公室搬遷"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <div className="bg-emerald-100 text-emerald-800 px-3 py-1 rounded-full text-sm font-semibold inline-block mb-3">
                    辦公室搬遷
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors">
                    台北信義區辦公室搬遷
                  </h3>
                  <p className="text-gray-600 text-sm">50坪科技公司，48小時完成搬遷</p>
                </div>
              </div>
            </Link>

            <Link to="/case-detail-3" className="group">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Cozy%20studio%20apartment%20with%20organized%20personal%20belongings%20in%20New%20Taipei%20Taiwan%2C%20compact%20living%20space%20moving%20service%2C%20efficient%20packing%20and%20furniture%20arrangement%20for%20young%20professional&width=600&height=400&seq=more-case-2&orientation=landscape"
                    alt="套房搬遷"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <div className="bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm font-semibold inline-block mb-3">
                    套房搬遷
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors">
                    新北新莊套房搬遷
                  </h3>
                  <p className="text-gray-600 text-sm">8坪套房，全套打包服務</p>
                </div>
              </div>
            </Link>

            <Link to="/case-detail-4" className="group">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Long%20distance%20moving%20truck%20on%20Taiwan%20highway%20with%20professional%20logistics%2C%20cross-city%20relocation%20from%20New%20Taipei%20to%20Taoyuan%2C%20secure%20cargo%20transport%20and%20modern%20moving%20service&width=600&height=400&seq=more-case-3&orientation=landscape"
                    alt="跨縣市搬家"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <div className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm font-semibold inline-block mb-3">
                    長途搬家
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors">
                    桃園中壢跨縣市搬家
                  </h3>
                  <p className="text-gray-600 text-sm">30坪家庭，一天完成搬遷</p>
                </div>
              </div>
            </Link>
          </div>

          <div className="text-center">
            <Link
              to="/cases"
              className="inline-flex items-center gap-2 bg-teal-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg"
            >
              <span>查看所有案例</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-br from-teal-50 via-white to-emerald-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white rounded-3xl shadow-2xl p-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">準備搬家了嗎？</h2>
            <p className="text-xl text-gray-600 mb-8">
              立即聯絡我們，免費估價，專業服務
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/quote"
                className="bg-teal-600 text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg flex items-center justify-center gap-2"
              >
                <i className="ri-calculator-line text-xl"></i>
                <span>線上免費估價</span>
              </Link>

              <a
                href="tel:0978900081"
                className="bg-white border-2 border-teal-600 text-teal-600 px-10 py-4 rounded-full text-lg font-semibold hover:bg-teal-50 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-phone-line text-xl"></i>
                <span>0978-900-081</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
